import React, { useState } from 'react';
import { connect } from 'react-redux';
import GLOBAL_STYLES from '../styles';
import ToolbarButton from './ToolbarButton';
import fastener from '../assets/fastener.png';
import { Form, Button } from 'react-bootstrap';
import { app } from '../state/actions';
import * as CONSTANTS from '../config';
import MoldChangeModal from './MoldChangeModal';
import JobChangeModal from './JobChangeModal';
import OperatorModal from './OperatorModal';
import { isAssemblyLocator } from '../helpers/misc';


const mapStateToProps = state => ({
  colorScheme: state.main.colorScheme,
  credentials: state.main.credentials,
  windowDimensions: state.main.windowDimensions,
  locators: state.app.locators,
  locatorFilter: state.app.locatorFilter,
  timelineViewType: state.app.timelineViewType,
  machineData: state.app.machineData,
  weekFilter: state.app.weekFilter,
});

const mapDispatchToProps = dispatch => ({
  updateLocatorFilter: payload => dispatch(app.updateLocatorFilter(payload)),
  updateTimelineViewType: payload => dispatch(app.updateTimelineViewType(payload)),
  updateTimelineTextFilter: payload => dispatch(app.updateTimelineTextFilter(payload)),
  updateWeekFilter: payload => dispatch(app.updateWeekFilter(payload)),
});


const Toolbar = props => {
  const {
    colorScheme,
    logout,
    windowDimensions,
    updateLocatorFilter,
    locatorFilter,
    locators,
    timelineViewType,
    updateTimelineViewType,
    updateTimelineTextFilter,
    machineData,
    updateWeekFilter,
    weekFilter,
  } = props;
  const [showMoldChangeModal, setShowMoldChangeModal] = useState(false);
  const [showJobChangeModal, setShowJobChangeModal] = useState(false);
  const [showOperatorModal, setShowOperatorModal] = useState(false);
  const [tempTimelineTextFilter, setTempTimelineTextFilter] = useState('');
  
  const handleLogoutClick = () => {
    if(window.confirm('Are you sure you want to logout?'))
      logout();
  };
  
  const hideMaterialSelection = machineData.filter(o => locatorFilter === 'ALL' || o.machineLocator === locatorFilter)
    .every(o => o.machineCategory === 'ASSEMBLY');
  
  return (
    <>
      <div
        style={{
          ...styles.toolbar,
          backgroundColor: GLOBAL_STYLES[colorScheme].bgColor,
          color: GLOBAL_STYLES[colorScheme].fgColor,
          borderBottomColor: GLOBAL_STYLES[colorScheme].fgColor,
        }}
      >
        <div style={styles.brandContainer}>
          {
            !windowDimensions || windowDimensions.width > 990 ?
              <img src={fastener} width="45" height="45" alt=""/> :
              null
          }
          {
            !windowDimensions || windowDimensions.width > 1215 ?
              <h3 style={styles.brandText}>{CONSTANTS.APP_DISPLAY_NAME}</h3>
              :
              null
          }
        </div>
        <div style={styles.filterGroup}>
          <div style={styles.formGroup}>
            <Form.Control
              as="select"
              size="sm"
              style={{ width: 175 }}
              value={locatorFilter}
              onChange={e => {
                updateWeekFilter('NONE');
                updateLocatorFilter(e.target.value);
                updateTimelineViewType('PART');
                updateTimelineTextFilter('');
                setTempTimelineTextFilter('');
              }}
            >
              {locators.map(unit => <option key={unit}>{unit}</option>)}
            </Form.Control>
          </div>
          <div style={styles.formGroup}>
            <Form.Control
              as="select"
              size="sm"
              style={{ width: 120 }}
              value={timelineViewType}
              onChange={e => {
                updateTimelineViewType(e.target.value);
                updateTimelineTextFilter('');
                setTempTimelineTextFilter('');
              }}
            >
              <option>PART</option>
              <option>JOB</option>
              <option>TOOL</option>
              <option>PACKAGING</option>
              {!hideMaterialSelection ? <option>MATERIAL</option> : null}
            </Form.Control>
          </div>
          {
            isAssemblyLocator(locatorFilter) ?
              <div style={styles.formGroup}>
                <Form.Control
                  as="select"
                  size="sm"
                  style={{ width: 120 }}
                  value={weekFilter}
                  onChange={e => {
                    updateWeekFilter(e.target.value);
                    updateTimelineTextFilter('');
                    setTempTimelineTextFilter('');
                  }}
                >
                  <option value="NONE">-- Select Week --</option>
                  <option>THIS WEEK</option>
                  <option>NEXT WEEK</option>
                </Form.Control>
              </div> :
              null
          }
          <div style={styles.formGroup}>
            <div style={styles.formGroupRow}>
              <Form.Control
                type="text"
                size="sm"
                style={{ width: 200 }}
                placeholder={`Search ${timelineViewType.toLowerCase()} number...`}
                value={tempTimelineTextFilter}
                onChange={e => setTempTimelineTextFilter(e.target.value)}
              />
              <Button
                size="sm"
                onClick={() => updateTimelineTextFilter(tempTimelineTextFilter)}
                style={{ marginLeft: 5 }}
              >
                GO
              </Button>
            </div>
          </div>
        </div>
        <div style={styles.buttonGroup}>
          {/* OPERATOR BUTTON */}
          {
            locatorFilter && locatorFilter !== 'ALL' ?
              isAssemblyLocator(locatorFilter) ?
              <ToolbarButton
                icon="fa-users"
                label="OPERATORS"
                onClick={() => setShowOperatorModal(true)}
              /> :
              <>
                {/* MOLD CHANGE BUTTON */}
                <ToolbarButton
                  icon="fa-wrench"
                  label="MOLD CHANGES"
                  onClick={() => setShowMoldChangeModal(true)}
                />
  
                {/* JOB CHANGE BUTTON */}
                <ToolbarButton
                  icon="fa-list"
                  label="JOB CHANGES"
                  onClick={() => setShowJobChangeModal(true)}
                />
              </> :
            null
          }
  
          {/* REFRESH BUTTON */}
          <ToolbarButton
            icon="fa-refresh"
            label="RELOAD"
            onClick={() => window.location.reload()}
          />
          
          {/* LOGOUT BUTTON */}
          <ToolbarButton
            icon="fa-sign-out"
            label="LOGOUT"
            onClick={handleLogoutClick}
          />
        </div>
      </div>
      
      <JobChangeModal
        show={showJobChangeModal}
        onHide={() => setShowJobChangeModal(false)}
      />
      <MoldChangeModal
        show={showMoldChangeModal}
        onHide={() => setShowMoldChangeModal(false)}
      />
      <OperatorModal
        show={showOperatorModal}
        onHide={() => setShowOperatorModal(false)}
      />
    </>
  );
};

const styles = {
  toolbar: {
    position: 'fixed',
    top: 0,
    right: 0,
    left: 0,
    minHeight: 90,
    height: 90,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 10,
    zIndex: 1,
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'row',
  },
  brandContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  brandText: {
    padding: 0,
    margin: '0 0 0 10px',
    fontSize: '2em',
    fontWeight: 'bold',
  },
  filterGroup: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dropdown: {
    width: 200,
  },
  formGroup: {
    margin: '0 15px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  formGroupRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar);